import { TransferTitleSubTitle } from ".";
import Layout from "../../../components/Accounts/Layout";
import { PaymentAmount } from "../../../components/Accounts/PaymentAmount";
import { styled } from "styled-components";
import PaymentDescription from "../../../components/Accounts/PaymentDescription";
import Button from "../../../components/Button/Button";
import { formatAmount } from "../../../utils/formatAmount";

interface SummaryProps {
  handleNext: () => void;
  values: any;
  title: string;
  paymentType: string;
  paymentSummary: { title: string; key: string }[];
}

const Summary: React.FC<SummaryProps> = ({
  handleNext,
  values,
  title,
  paymentType,
  paymentSummary,
}) => {
  const amount = values.Amount;

  return (
    <Layout>
      <TitleWrapper>
        <TransferTitleSubTitle>{paymentType}</TransferTitleSubTitle>
        <PaymentAmount amount={amount} currency={"$"} />
      </TitleWrapper>
      <div>
        {paymentSummary.map((item) => (
          <PaymentDescription
            key={item.title}
            title={item.title}
            description={
              item.key === "Amount"
                ? formatAmount(amount)
                : item.key === "TransactionFee"
                  ? formatAmount(values.TransactionFee)
                  : values[item.key]
            }
          />
        ))}
      </div>
      <Button
        id={""}
        type="button"
        onClick={handleNext}
        padding={"10px 45%"}
        title={title}
        border="10px"
        green
      />
    </Layout>
  );
};

export default Summary;

export const TitleWrapper = styled.div`
  text-align: center;
`;
